import Vue from 'vue'
import Vuex from 'vuex'
import zh from '../../../i18n/zh-cn.toml'
import en from '../../../i18n/en-us.toml'
import fr from '../../../i18n/fr-fr.toml'
import ko from '../../../i18n/ko-kr.toml'
import de from '../../../i18n/de-de.toml'
import pt from '../../../i18n/pt-br.toml'
import {getLang,postJsError} from '@/util/util.js'
import { EventBus } from './event-bus';
import { API_URL } from '@/constants/const.js'
import axios from 'axios';
Vue.use(Vuex)
var config;
const lang = getLang();
switch (lang) {
  case 'zh-cn':
    config = zh;
    break;
  case 'en-us':
    config = en;
    break;
  case 'fr-fr':
    config = fr;
    break;
  case 'ko-kr':
    config = ko;
    break;
  case 'de-de':
    config = de;
    break;
  case 'pt-br':
    config = pt;
    break;
  default:
    config = zh;
    break;
}

export default new Vuex.Store({
  state: {
    breadcrumbItems: [], // 默认空数组
    warnListData:{},//告警
    lang: config, // 默认使用本地语言配置
    prodSpotRefresh:[], //焊点管理是否已刷新
    queryDate:[new Date(),new Date()],
    language:'zh-cn', //默认语言
  },
  mutations: {
    setBreadcrumbItems(state, items) {
      state.breadcrumbItems = items
    },
    setWarnList(state, { macId, data }) {
      Vue.set(state.warnListData, macId, data)
    },
    setLang(state, langData) {
      state.lang = langData
      // 同时更新全局变量，保持兼容性
      Vue.prototype.$lang = langData
    },
    setLanguage (state, language){
      state.language = language
      // 同时更新全局变量，保持兼容性
      Vue.prototype.$language = language
    },
    setProdSpotRefresh(state, val) {
      state.prodSpotRefresh = val
    },
    setQueryDate(state, val) {
      state.queryDate = val
    },
  },
  actions: {
    // 更新语言数据
    updateLang({ commit }, langData) {
      commit('setLang', langData)
    },
    updateLanguage({ commit }, language) {
      commit('setLanguage', language)
    },
    

    // 从服务器获取语言数据
    async fetchLang({ commit }) {
      let language = '';
      try {
          language = localStorage.getItem('system.lang');
          if(!language){
            let url = API_URL["langGet"];
              let params = {
              }
              let res = await axios.get(url, {
                  params: params
              })
              .catch((err) => {
                  postJsError(err)                
              })
              if (res && res.data && res.data.code == 200) {
                if(res.data.data.lang){
                  language = res.data.data.lang
                  switch (language) {
                    case 'zh-cn':
                      config = zh;
                      break;
                    case 'en-us':
                      config = en;
                      break;
                    case 'fr-fr':
                      config = fr;
                      break;
                    case 'ko-kr':
                      config = ko;
                      break;
                    case 'de-de':
                      config = de;
                      break;
                    case 'pt-br':
                      config = pt;
                      break;
                    default:
                      config = zh;
                      break;
                  }
                  localStorage.setItem('system.lang', language);
                }
              }
            }
          
          EventBus.$emit('lang-finish',language);         
      } catch (error) {
        console.error('Failed to fetch language data:', error)
        // 使用默认配置
      }
      commit('setLang', config)
      commit('setLanguage', language)
      return config
    }
  },
  getters: {
    // 获取语言数据
    getLang: state => state.lang,

    getLanguage:state=>state.language,
    // 获取特定键值的翻译
    getTranslation: state => key => {
      return state.lang[key] || key
    },
    getProdSpotRefresh:state => state.prodSpotRefresh,

    getQueryDate: state => state.queryDate,
  }
})